import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'cigna-dialog-privacy',
  templateUrl: './dialog-privacy.component.html',
  styleUrls: ['./dialog-privacy.component.scss'],
})
export class DialogPrivacyComponent {
  constructor(public dialogRef: MatDialogRef<DialogPrivacyComponent>) {}
}
